type CircularProgressBarProps = {
    progress: number; // 0 to 1
    radius?: number;
    stroke?: number;
    className?: string;
    progressColors?: { foreground: string; background: string };
    children?: React.ReactNode;
};

export function CircularProgressBar({
    progress,
    radius = 45,
    stroke = 6,
    className = '',
    progressColors = {
        foreground: 'var(--color-action-orange)',
        background: 'var(--color-secondary-green-light)',
    },
    children,
}: CircularProgressBarProps) {
    progress = Math.min(Math.max(progress, 0), 1); // Clamp progress between 0 and 1
    const normalizedRadius = radius - stroke / 2;
    const circumference = 2 * Math.PI * normalizedRadius;
    const strokeDashoffset = circumference * (1 - progress);

    return (
        <div
            className="relative"
            style={{ width: radius * 2, height: radius * 2 }}
        >
            <svg
                height="100%"
                width="100%"
                viewBox={`0 0 ${radius * 2} ${radius * 2}`}
            >
                <circle
                    stroke={progressColors.background}
                    fill="transparent"
                    strokeWidth={stroke}
                    r={normalizedRadius}
                    cx={radius}
                    cy={radius}
                />
                <circle
                    stroke={progressColors.foreground}
                    fill="transparent"
                    strokeWidth={stroke}
                    strokeLinecap="round"
                    strokeDasharray={`${circumference} ${circumference}`}
                    strokeDashoffset={strokeDashoffset}
                    r={normalizedRadius}
                    cx={radius}
                    cy={radius}
                    transform={`rotate(-90 ${radius} ${radius})`}
                />
            </svg>
            <div
                className={`absolute inset-0 flex items-center justify-center ${className}`}
            >
                {children}
            </div>
        </div>
    );
}
